import React from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const SimilarEntityAlert = ({ similarMatch, entityName, onKeepExisting, onUseNew }) => {
  const { t } = useTranslation();

  if (!similarMatch || similarMatch.action) {
    return null;
  }

  const message = similarMatch.isExactMatch
    ? `${t('Entity already exists in system')}: ${similarMatch.similarEntity.divName}`
    : `${t('Similar entity found')}: ${similarMatch.similarEntity.divName}`;

  return (
    <div className="mb-2 d-flex justify-content-between align-items-center">
      <div>
        <strong>{message}</strong>
      </div>
      <div>
        <Button variant="outline-secondary" size="sm" className="mr-2" onClick={() => onKeepExisting(entityName)}>
          {t('Use Existing')}
        </Button>
        <Button variant="outline-secondary" size="sm" onClick={() => onUseNew(entityName)}>
          {t('Use New')}
        </Button>
      </div>
    </div>
  );
};

export default SimilarEntityAlert;
